exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswersQuestion{padding:10px;display:flex;flex-wrap:wrap}.AnswersQuestion .ItemsCategoryAnswers{width:100%}.AnswersQuestion .ItemsCategoryAnswers .items{display:flex;flex-wrap:wrap}.AnswersQuestion .item_answer_question{width:200px;min-width:200px;min-height:50px;background:#fff;border:1px solid #d8d8d8;border-radius:0;margin:10px;display:flex;align-items:center;justify-content:center;text-align:center;padding:5px;overflow:hidden;overflow-x:auto}.AnswersQuestion .item_answer_question img{max-width:100%;max-height:100%}.AnswersQuestion .item_answer_question.isTrue{border-color:#67d46c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/Questions/components/Item/components/Answers/style.scss
// module id = 5203
// module chunks = 0